<app-ion-common-header [id]="headerId" (backHeader)="backPage()" (focusHeader)="shownContent()" [title]="titleWebPage"></app-ion-common-header>

<ion-content [attr.aria-hidden]="ariaHidden" [style.visibility]="ariaHidden ? 'hidden' : 'visible'"
*ngIf="journeyService.registratioJourney?.data?.personalData">

  <div class="content-scroll content-scroll--button-md">
    <app-ion-common-label class="document-type-label1" labelStyle="display-rg" 
      [labelDescription]="title" [labelAria]="labelAria">
    </app-ion-common-label>

    <div class="conent-center conent-center--ph-0">
      <app-ion-common-data-list class="document-type-label1" labelStyle="display-rg" 
        [labelTitle]="titleProfile" [ariaLevel]="3" [idLink]="'editar-perfil'" (editClick)="editField($event)"
        linkSubtitle="Editar" linkSubtitleAriaLabel="editar dados de contato" [itens]="itensProfile">
      </app-ion-common-data-list>
      
      <app-ion-common-data-list class="document-type-label1" labelStyle="display-rg" 
        [labelTitle]="titlePersonal" [ariaLevel]="3" [idLink]="'editar-dados-pessoais'" (editClick)="editField($event)"
        [linkSubtitle]="editPersonal" linkSubtitleAriaLabel="editar dados pessoais" [itens]="itensPersonal" [textEditFalse]="msgEditDisabledPersonal">
      </app-ion-common-data-list>
      
      <app-ion-common-data-list class="document-type-label1" labelStyle="display-rg"
        [labelTitle]="titleMarital" [ariaLevel]="3" [idLink]="'editar-estado-civil'" (editClick)="editField($event)"
        linkSubtitle="Editar" linkSubtitleAriaLabel="editar dados estado civil" [itens]="itensMarital">
      </app-ion-common-data-list>
      
      <app-ion-common-data-list class="document-type-label1" labelStyle="display-rg"
        [labelTitle]="titleAddress" [ariaLevel]="3" [idLink]="'editar-endereco'" (editClick)="editField($event)"
        [linkSubtitle]="editAddress" linkSubtitleAriaLabel="editar endereço" [itens]="itensAddress" [textEditFalse]="msgEditDisabledAddress">
      </app-ion-common-data-list>
      
      <app-ion-common-data-list class="document-type-label1" labelStyle="display-rg"
        [labelTitle]="titleProfessional" [ariaLevel]="3" [idLink]="'editar-dados-profissionais'" (editClick)="editField($event)"
        linkSubtitle="Editar" linkSubtitleAriaLabel="editar dados profissionais" [itens]="itensProfessional">
      </app-ion-common-data-list>
      
      <app-ion-common-data-list class="document-type-label1 margin-data" labelStyle="display-rg"
        [labelTitle]="titleIncome" [ariaLevel]="3" [idLink]="'editar-renda'" (editClick)="editField($event)"
        linkSubtitle="Editar" linkSubtitleAriaLabel="editar dados renda e patrimônio" [itens]="itensIncome">
      </app-ion-common-data-list>
      
      <div class="paragraph">
        <p class="paragraph__text">
          Ao continuar, você tem a ciência de que suas informações serão utilizadas de acordo com os Termos de uso e Política de Privacidade.
             Acesse nosso site para mais informações: www.itau.com.br/privacidade
        </p>
      </div>
    </div>
  </div>

  <app-ion-common-button class="hidden button-enc" [ngClass]="{'hidden': !buttonEnable}" [attr.aria-hidden]="!buttonEnable"
  label="Continuar" (clickButton)="clickNext();"></app-ion-common-button>
</ion-content>

<ion-content *ngIf="!journeyService.registratioJourney?.data?.personalData" [attr.aria-hidden]="ariaHidden">
  <app-ion-common-retry
    [headerId]="headerId"
  >
  </app-ion-common-retry>
</ion-content>
